import React, { useEffect, useState } from 'react';
import Hero from './Hero';
import Indexed from './Indexed';
import Announcements from './Announcements';
import Current from './Current';
import { Link } from 'react-router-dom';
import HomeIssues from './HomeIssues';
import HomeArticles from './HomeArticles';

function Home({title}) {

    useEffect(() => {
        document.title = title;
    }, [title]);

    const [latestIssue, setLatestIssue] = useState([]);

    useEffect(() => {
        fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=getAllIssues')
          .then(res => res.json())
          .then(data => {
            if (data.success) {
              const publishedIssues = data.issues
                .filter(issue => issue.publish === 1)
                .slice(0, 1);
    
              setLatestIssue(publishedIssues);
            }
          })
          .catch(err => console.error('Failed to fetch issues:', err));
      }, []);


    return (
      <>
        <Hero/>
        <Indexed/>
        <div className='curr_ann_section'>
          <div className='curr_ann_wrapper'>
              <div className='curr_ann_left'>
                <Current issue={latestIssue[0]}/>

                <div>
                  <div className='onea_hr'>

                  </div>

                  <div className='ann_link_wrapper'>
                      <Link to={`/articles?issue=${latestIssue[0]?.id}`} className='ann_link'>Current Issue&nbsp;&nbsp;<span className="fa-solid fa-angle-right"></span></Link>
                  </div>
                </div>
                
              </div>
              <div className='curr_ann_right'>
                <Announcements/>

                <div>
                  <div className='onea_hr'>

                  </div>

                  <div className='ann_link_wrapper'>
                    <Link to="announcements" className='ann_link'>Announcements History&nbsp;&nbsp;<span className="fa-solid fa-angle-right"></span></Link>
                  </div>
                </div>

              </div>
          </div>
        </div>
        <HomeArticles/>
        <HomeIssues/>
      </>
    );
}

export default Home;